import { combineSlices } from '@reduxjs/toolkit';

import { organizationSlice } from '@/app/core/app/organization/domain/state/organizationSlice';
import { authSlide } from '@/app/core/auth/infrastructure/redux/authSlice';

/**
 * Feature slices register their state shape here through declaration merging,
 * so `RootState` stays fully typed without the platform importing any feature:
 *
 *   declare module '@/platform/store/rootReducer' {
 *     interface LazyLoadedSlices extends WithSlice<typeof agentConfigSlice> {}
 *   }
 *
 * The slices themselves are injected by `createAppStore` from the app's module
 * manifests, so a dashboard only carries the state it mounts.
 */
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface LazyLoadedSlices {}

/** Core slices every dashboard has: session + current organization. */
export const createRootReducer = () =>
  combineSlices(authSlide, organizationSlice).withLazyLoadedSlices<LazyLoadedSlices>();

export type RootReducer = ReturnType<typeof createRootReducer>;
export type RootState = ReturnType<RootReducer>;
